module.exports = "<i ng-if=vm.showIcon class=\"fa fa-save autosaver\" aria-hidden=true></i> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-autosaver/cn-autosaver.html
 ** module id = 135
 ** module chunks = 0
 **/